* {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex-direction: column;
  padding: $xp-ref-spacing-2;
  box-shadow: $xp-ref-elevation-neutral-3;
  background-color: $xp-ref-color-brand-on-primary-brand;
}

.item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: $xp-ref-spacing-2 0 $xp-ref-spacing-2 0;
  gap: 8px;

  .name {
    font: $xp-ref-font-paragraph-paragraph-short;
    color: $xp-ref-color-text-default-dark;
  }

  .price {
    font: $xp-ref-font-paragraph-paragraph-short;
    color: $xp-ref-color-text-default-medium;
  }
}

.total {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: $xp-ref-spacing-2 0 $xp-ref-spacing-2 0;
  gap: 8px;
  border-top: 1px solid $xp-ref-color-border-medium;
  .total-text {
    font: $xp-ref-font-paragraph-paragraph-short;
    font-weight: 700;
    color: $xp-ref-color-text-default-dark;
  }
  .total-price {
    font: $xp-ref-font-paragraph-paragraph-short;
    font-weight: 700;
    color: $xp-ref-color-text-default-medium;
  }
}

.button {
  padding-top: $xp-ref-spacing-2;
  gap: 8px;
  width: 100%;
  display: flex;
}
